import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlgChannelService } from "./channel.service";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from '../../../shared';

@Injectable({ providedIn: "root" })
export class WhatsappBusinessService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl =	 Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "whatsapp-api/send";
    this.endpointPath =Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UCC_MODULE + "whatsapp-api/send";
    this.httpClient = httpClient;

  }

  broadcastWhatsappBusiness(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    let url = this.apiUrl + '/broadcast ';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

}
